var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-fee-amount" },
    [
      _c("p", { class: [{ "required-flag": _vm.canUpdate }, "blod-p"] }, [
        _vm._v(_vm._s(_vm.$t("tenantProjects.managementFeeAmount"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btns" }, [
        _vm.canUpdate && !_vm.canNotifyAccounting
          ? _c(
              "button",
              { staticClass: "btn btn--darkblue", on: { click: _vm.notifyPM } },
              [_vm._v(_vm._s(_vm.$t("tenantProjects.notifyPM")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.canNotifyAccounting
          ? _c(
              "button",
              {
                staticClass: "btn btn--darkblue margin-left-15",
                on: { click: _vm.notifyAccounting },
              },
              [_vm._v(_vm._s(_vm.$t("tenantProjects.notifyAccounting")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEngineer
          ? _c("div", { staticClass: "management-fee-notify-info" }, [
              _vm.notifyPMInfo && _vm.canRead
                ? _c("i", { staticClass: "gray-font" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tenantProjects.notifyPMByAt", [
                          _vm.notifyPMInfo.by,
                          _vm.notifyPMInfo.time,
                        ])
                      )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.notifyAccountingInfo
                ? _c("i", { staticClass: "gray-font" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tenantProjects.notifyAccountingByAt", [
                          _vm.notifyAccountingInfo.by,
                          _vm.notifyAccountingInfo.time,
                        ])
                      )
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isEngineer
        ? _c("div", [
            _c(
              "div",
              { staticClass: "choose-management-fee-amount" },
              [
                _c("input", {
                  attrs: {
                    type: "radio",
                    checked: "",
                    disabled: !_vm.canUpdate,
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "management-fee-amount-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("tenantProjects.managementFeeAmount")) + " "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "management-fee-amount-label currency-prefix",
                  },
                  [_vm._v(_vm._s(_vm.$globalProps.getCurrency()))]
                ),
                _vm._v(" "),
                _c("InputField", {
                  staticClass: "input-management-fee-amount",
                  attrs: {
                    readonly: !_vm.canUpdate && !_vm.isEditingAmount,
                    showColon: false,
                    placeholder: "0.00",
                    showFlag: false,
                    value: _vm.amount,
                    showEmptyDash: true,
                    readonlyAsInput: _vm.isNotifiedPM && !_vm.isEditingAmount,
                    inputTip: _vm.hintString,
                    inputCheckType: "decimal",
                    pattern: _vm.regex.decimal,
                    parentNode: _vm.FORM_SRC_PROJECT_CONTROL,
                    required: true,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.updateAmount(val)
                    },
                  },
                }),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.isNotifiedPM &&
                        !_vm.isEditingAmount &&
                        _vm.canUpdate,
                      expression:
                        "isNotifiedPM && !isEditingAmount && canUpdate",
                    },
                  ],
                  staticClass: "fa fa-pencil",
                  on: {
                    click: function ($event) {
                      _vm.isEditingAmount = true
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm.isUserNotifyAccounting
        ? _c("div", [
            _c("label", { staticClass: "medium-size margin-right-15" }, [
              _vm._v(_vm._s(_vm.$globalProps.getCurrency() + " ") + " "),
              _c("span", { staticClass: "blod-p" }, [
                _vm._v(_vm._s(_vm.showAmount)),
              ]),
            ]),
          ])
        : _c("div", [_vm._v("\n    " + _vm._s(_vm.$t("emptyValue")) + "\n  ")]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "management-fee-input-modal",
          staticClass: "management-fee-input-modal",
          attrs: {
            modalType: "small-modal",
            showCloseBtn: false,
            modalId: "management-fee-input-modal_" + _vm.tenantProjectId,
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "font-bold",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _vm._v(
                _vm._s(_vm.$t("tenantProjects.inputAccountingHint") + " ") +
                  "\n      "
              ),
              _c("span", [_vm._v(_vm._s(_vm.accountingEmail || "--"))]),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              { staticClass: "btn--darkblue", on: { click: _vm.closeModal } },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--orange",
                on: { click: _vm.sendEmailToAccounting },
              },
              [_vm._v(_vm._s(_vm.$t("action.send")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }